import { render, staticRenderFns } from "./result.vue?vue&type=template&id=5b833c1c&scoped=true&"
import script from "./result.vue?vue&type=script&lang=ts&"
export * from "./result.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b833c1c",
  null
  
)

export default component.exports